import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';
import { useState } from 'react';
import TextField from "@mui/material/TextField";
import {
  FormControl,
  FormLabel,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import axios from "axios";
import { PopUpMessage } from "../../../shared/components/PopUpMessage";
import markerIconPng from 'leaflet/dist/images/marker-icon.png';

const SERVER = process.env.REACT_APP_SERVER;


const defaultIcon = new Icon({ iconUrl: markerIconPng, iconSize: [25, 41], iconAnchor: [12, 41] });
const bigIcon = new Icon({ iconUrl: markerIconPng, iconSize: [35, 57], iconAnchor: [17, 57], popupAnchor: [0, -57] });

const locations = [
    {
        id: 'ubc',
        name: 'UBC',
        position: [49.2606, -123.2460],
    },
    {
        id: 'lougheed',
        name: 'LOUGHEED',
        position: [49.2495, -122.8942],
    },
    {
        id: 'langara',
        name: 'Langara',
        position: [49.2244, -123.1086],
    },
    /*
    {
        id: 'richmond',
        name: 'RICHMOND',
        position: [49.1962, -123.0694],
    },
    */
    /*
    {
        id: 'brentwood',
        name: 'Brentwood',
        position: [49.2681, -123.0002],
    },
    */
    {
        id: 'metrotown',
        name: 'Metrotown',
        position: [49.2245, -123.0027],
    },
    /*
    {
        id: 'burquitlam',
        name: 'Burquitlam',
        position: [49.2632, -122.8880],
    },
    {
        id: 'marine',
        name: 'Marine Drive',
        position: [49.2097, -123.1169],
    },
    */
];

const MENU_PRICES: Record<string, number> = {
  saltedeggchicken: 13,
  risolmayo: 6,
};

const MENU_LABELS: Record<string, string> = {
  saltedeggchicken: "Salted Egg Chicken",
  risolmayo: "Risol Mayo (2 pcs)",
};

const LOCATION_LABELS: Record<string, string> = {
  ubc: "UBC",
  lougheed: "LOUGHEED",
  langara: "Langara",
  metrotown: "Metrotown",
  /*
  richmond: "RICHMOND",
  brentwood: "Brentwood",
  burquitlam: "Burquitlam",
  marine: "Marine Drive",
  */
  
};

const PICKUP_TIMES: Record<string, string> = {
  ubc: "Saturday, October 24, 15:00-18:00",
  lougheed: "Saturday, October 24, 15:00-18:00",
  metrotown: "Saturday, October 24, 15:00-18:00",
  langara: "Saturday, October 24, 15:00-18:00",
  /*
  richmond: "Saturday, September 19, 16:00-18:00",
  brentwood: "Sunday, April 5, 10:00-12:00",
  burquitlam: "Sunday, April 5, 20:00-22:00",
  marine: "Sunday, April 5, 18:00-20:00",
  */
};

const generateTimeSlots = (range: string) => {
  if (!range) return [];

  // Remove the date and keep only the time ranges
  const parts = range.split(", ");
  const timeRanges = parts[parts.length - 1]
    .split("&")
    .map((r) => r.trim());

  const slots: string[] = [];

  timeRanges.forEach((timeRange) => {
    if (!timeRange.includes("-")) return;

    const [start, end] = timeRange.split("-");

    const startDate = new Date(`1970-01-01T${start}:00`);
    const endDate = new Date(`1970-01-01T${end}:00`);

    let current = new Date(startDate);

    while (current < endDate) {
      const next = new Date(current);
      next.setMinutes(next.getMinutes() + 30);

      if (next <= endDate) {
        const format = (d: Date) =>
          d.toTimeString().slice(0, 5);

        slots.push(`${format(current)} - ${format(next)}`);
      }

      current.setMinutes(current.getMinutes() + 30);
    }
  });

  return slots;
};

const calculateMenuTotal = (menus: { item: string; quantity: number }[]) => 
  menus.reduce((sum, m) => sum + (MENU_PRICES[m.item] || 0) * m.quantity, 0);

export const WaroengForm = () => {
    const [state, setState] = useState({
        name: "",
        email: "",
        saltedEggChickenQty: 1,
        risolMayoQty: 0,
        pickup: "",
        timeSlot: "",
        proofOfPayment: null as File | null
    });
    const [popUpMessage, setPopUpMessage] = useState("");
    const [popUpOpen, setPopUpOpen] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [orderSuccess, setOrderSuccess] = useState(false);
  
    const handleFieldChange = (field: string, value: any) => {
        setState((prev) => ({ ...prev, [field]: value }));
    };

    const menuItems = [
    { item: "saltedeggchicken", quantity: state.saltedEggChickenQty },
    { item: "risolmayo", quantity: state.risolMayoQty },
    ].filter((m) => m.quantity > 0);

    
    let total = calculateMenuTotal(menuItems);
  
    


    const activeLocation = locations.find((l) => l.id === state.pickup);

    const pickupRange = PICKUP_TIMES[state.pickup];
    const timeSlots = generateTimeSlots(pickupRange);

    const handleFailure = () => {
        setPopUpMessage("Service unavailable, please try again in a minute.");
        setPopUpOpen(true);
    };

    const handleSubmit = async () => {
        if (!state.name || !state.email || menuItems.length === 0 || !state.pickup || !state.timeSlot || !state.proofOfPayment) {
            setPopUpMessage("Please fill out all required fields.");
            setPopUpOpen(true);
            return;
        }

        setSubmitted(true);

        try {

            setPopUpMessage("Uploading proof of payment...");
            setPopUpOpen(true);

            // Upload proof of payment to S3
            const presignRes = await axios.post(`${SERVER}/s3/presign-url`, {
                fileName: state.proofOfPayment.name,
                fileType: state.proofOfPayment.type,
            });

            const { url, objectUrl } = presignRes.data;

            await axios.put(url, state.proofOfPayment, {
                headers: { "Content-Type": state.proofOfPayment.type },
            });

            setPopUpMessage("Processing order...");

            const countRes = await axios.get(`${SERVER}/waroeng/no-of-orders`);
            const count = countRes.data.count;

            let menuString = menuItems
                .map((m) => `${MENU_LABELS[m.item] || m.item} x${m.quantity}`)
                .join(", ");

            const body = {
                name: state.name,
                email: state.email,
                menu: menuString,
                quantity: state.saltedEggChickenQty + state.risolMayoQty,
                pickupLocation: LOCATION_LABELS[state.pickup] || state.pickup,
                pickupTime: state.timeSlot,
                totalPrice: total,
                proofOfPayment: objectUrl,
                orderNumber: count + 1,
            };

            const pickupTime = `${PICKUP_TIMES[state.pickup]} | Slot: ${state.timeSlot}`;
            
            const emailBody = {
                to: state.email,
                subject: "Waroeng Order Confirmation",
                html: `<p>Dear ${state.name},</p><p>Thank you for your order!</p><p><strong>Order Details:</strong></p><p>${menuString}</p><p><strong>Total:</strong> $${total.toFixed(2)}</p><p><strong>Pickup Location:</strong> ${LOCATION_LABELS[state.pickup]}</p><p><strong>Pickup Time:</strong> ${pickupTime}</p><p><em>The exact pickup address will be emailed to you closer to the pickup date.</em></p><p>We'll see you soon!</p>`,
            };

            await axios.post(`${SERVER}/waroeng/order`, body);
            await axios.post(`${SERVER}/email/send-mail`, emailBody);

            setOrderSuccess(true);
            setPopUpMessage("Order submitted successfully! Check your email for confirmation.");
            setTimeout(() => {
                setPopUpOpen(false);
            }, 3000);
        } catch (error) {
            handleFailure();
            setSubmitted(false);
        }
    };

    if (orderSuccess) {
        return (
            <div className="min-h-screen w-full bg-white text-black flex items-center justify-center py-8">
                <div className="flex flex-col items-center w-11/12 lg:w-3/4 gap-6">
                    <h1 className="text-2xl font-semibold text-center text-[#D07D14]">Order Submitted Successfully!</h1>
                    <p className="text-center">Thank you for your order. Check your email for confirmation details.</p>
                    <p className="text-center text-sm text-gray-600">Order Total: <span className="font-semibold">${total.toFixed(2)}</span></p>
                    <p className="text-center text-sm text-gray-600">Pickup Location: <span className="font-semibold">{LOCATION_LABELS[state.pickup]}</span></p>
                </div>
            </div>
        );
    }

    return (
        <>
        <PopUpMessage
            open={popUpOpen}
            handleClose={() => setPopUpOpen(false)}
            message={popUpMessage}
        />
        <div className="min-h-screen w-full bg-white text-black flex items-center justify-center py-8">
        <div className="flex flex-col items-center w-11/12 lg:w-3/4 gap-6">
        <h1 className="text-2xl font-semibold text-center">- This Waroeng's Menu -</h1>
        <img src='/Waroeng_Vol2.jpeg' alt='Waroeng Vol.2 poster' className='w-full max-w-xl mb-6' />

        <div className="w-full flex flex-col gap-4">
          <TextField
            label="Name*"
            value={state.name}
            onChange={(e) => handleFieldChange("name", e.target.value)}
            fullWidth
          />
          <TextField
            label="Email*"
            value={state.email}
            onChange={(e) => handleFieldChange("email", e.target.value)}
            fullWidth
          />
        </div>

        <FormControl component="fieldset" className="w-full">
          <FormLabel focused={false}>Select your menu*</FormLabel>

          <div className="mt-2">
          <p className="text-lg font-medium">Salted Egg Chicken (comes with egg) — $13/portion</p>
          <Select
            value={state.saltedEggChickenQty}
            onChange={(e) =>
              handleFieldChange("saltedEggChickenQty", Number(e.target.value))
            }
            sx={{ width: "100%", maxWidth: "150px", mt: 1 }}
            MenuProps={{ disablePortal: true }}
          >
            {[...Array(11)].map((_, i) => (
              <MenuItem key={i} value={i}>
                {i}
              </MenuItem>
            ))}
          </Select>
        </div>

          <div className="mt-4">
          <p className="text-lg font-medium">Risol Mayo — $6 for 2 pcs</p>
          <Select
            value={state.risolMayoQty}
            onChange={(e) =>
              handleFieldChange("risolMayoQty", Number(e.target.value))
            }
            sx={{ width: "100%", maxWidth: "150px", mt: 1 }}
            MenuProps={{ disablePortal: true }}
          >
            {[...Array(11)].map((_, i) => (
              <MenuItem key={i} value={i}>
                {i === 0 ? "0" : `${i} (${i * 2} pcs)`}
              </MenuItem>
            ))}
          </Select>
        </div>

        

        </FormControl>

        <div className="w-full">
          <FormLabel focused={false}>Pickup Location</FormLabel>
          <p className="text-sm text-gray-500 mb-2">
            Click on a marker to select your pickup location.
          </p>

          <div className="w-full h-[50vh] rounded-lg overflow-hidden border">
            <MapContainer
              center={[49.2606, -123.1207]}
              zoom={window.innerWidth >= 768 ? 11 : 10}
              minZoom={9}  // Prevent zooming out too far on desktop
              maxZoom={15}  // Prevent zooming in too close
              style={{ height: "100%", width: "100%" }}
              zoomControl={true}
              touchZoom={true}
              zoomSnap={0.5}
              zoomDelta={0.5}
            >
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {locations.map((loc) => (
                <Marker
                  key={loc.id}
                  position={loc.position as [number, number]}
                  icon={state.pickup === loc.id ? bigIcon : defaultIcon}
                  eventHandlers={{
                    click: () => {
                      handleFieldChange("pickup", loc.id);
                      handleFieldChange("timeSlot", "");
                    },
                  }}
                />
              ))}
            </MapContainer>
          </div>

          <p className="mt-2 text-sm">
            Selected:{" "}
            <span className="text-[#D07D14] font-medium">
              {activeLocation ? activeLocation.name : "-"}
            </span>
          </p>
        </div>
        
        {state.pickup && (
              <div className="mt-4">
                <p className="text-lg font-medium mb-1">Select Pickup Time</p>
                <Select
                  value={state.timeSlot}
                  onChange={(e) => handleFieldChange("timeSlot", e.target.value)}
                  sx={{
                    width: "100%",           
                    maxWidth: "150px",      
                    mt: 1,                   
                    fontSize: "1rem",      
                    "& .MuiSelect-select": { paddingY: "8px" }, 
                  }}
                  MenuProps={{ disablePortal: true }}
              >
                {timeSlots.map((slot) => (
                  <MenuItem key={slot} value={slot}>
                    {slot}
                  </MenuItem>
                ))}
              </Select>

            </div>
          )}

      
        <div className="w-full">
          <FormLabel focused={false}>Proof of Payment*</FormLabel>
          <br />
          <FormLabel focused={false}>Interac to: treasurer.permikavancouver@gmail.com</FormLabel>
          <input
            type="file"
            accept="image/*,application/pdf"
            onChange={(e) =>
              handleFieldChange("proofOfPayment", e.target.files?.[0] || null)
            }
            className="mt-2"
            style={{ display: "block" }}
          />
        </div>

        <div className="flex flex-col items-center mt-4">
          <p className="text-lg font-medium mb-3">
            Total: <span className="text-[#D07D14]">${total.toFixed(2)}</span>
          </p>

          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={{
              backgroundColor: "#D07D14",
              "&:hover": { backgroundColor: "#b66910" },
              textTransform: "none",
              fontSize: "1rem",
              paddingX: "2rem",
            }}
            disabled= {
              !state.name ||
              !state.email ||
              menuItems.length === 0 ||
              !state.pickup ||
              !state.timeSlot ||
              !state.proofOfPayment ||
              submitted
            }
            // {
            //   !state.name || !state.email || !state.pickup || !state.timeSlot || !state.proofOfPayment || submitted
            // }
          >
            {submitted ? "Submitting..." : "Submit Order"}
          </Button>
        </div>
      </div>
    </div>
    </>
  );
};

